import React from "react";

import _vivo from "../../../img/ico_vivo.png";
import _specVivo from "../../../img/ico_specVivo.png";
import _liveTime from "../../../img/ico_liveTime.png";
import _peakLive from "../../../img/ico_peakLive.png";

function FirstRow({
    isLoading = true,
    isError = false,
    live_viewers = 0,
    total_viewers = 0,
    average_time = 0,
    viewers_peak = 0 }){

    if ((!isLoading) && (total_viewers === 0 || total_viewers === null)){
        return (<div className="row row-sm row-xl">
            <div className="col-md-12">
                <div className="card card-minimal-four">
                    <div className="card-header">
                        <div className="media">
                            <h6>Aún no se ha conectado nadie a tu evento.</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }

    if (isError){
        return (<div className="row row-sm row-xl">
            <div className="col-md-12">
                <div className="card card-minimal-four">
                    <div className="card-header">
                        <div className="media">
                            <div className="alert alert-danger mg-t-30 tx-center">
                                <span>En este momento no es posible cargar esta sección, por favor vuelve en unos momentos</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }

    return (
        <div className="row row-sm row-xl">
            <div className="col-md-6 mg-t-0 mg-sm-t-0">
                <div className="card card-minimal-four">
                    <div className="card-header">
                        <div className="media">
                            {(isLoading) && <i className="fas fa-spinner fa-spin"></i>}
                            {(!isLoading) && (
                                <React.Fragment>
                                    <div className="coin-logo">
                                        <img src={_vivo} alt="" />
                                    </div>
                                    <div className="media-body event-resume">
                                        <h6><small>Hay</small> {live_viewers}</h6>
                                        <p><small> espectador{(live_viewers !== 1 ? "es" : "")} viendo tu evento en este momento</small></p>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-6 mg-t-0 mg-sm-t-0 mg-xs-t-20">
                <div className="card card-minimal-four">
                    <div className="card-header">
                        <div className="media">
                            {(isLoading) && <i className="fas fa-spinner fa-spin"></i>}
                            {(!isLoading) && (
                                <React.Fragment>
                                    <div className="coin-logo">
                                        <img src={_specVivo} alt="" />
                                    </div>
                                    <div className="media-body event-resume">
                                        <h6><small>Un total de </small> {total_viewers}</h6>
                                        <p><small> espectador{(total_viewers !== 1 ? "es" : "")} han visto tu evento</small></p>
                                            
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-6 mg-t-20 mg-sm-t-20">
                <div className="card card-minimal-four">
                    <div className="card-header">
                        <div className="media">
                            {(isLoading) && <i className="fas fa-spinner fa-spin"></i>}
                            {(!isLoading) && (
                                <React.Fragment>
                                    <div className="coin-logo">
                                        <img src={_liveTime} alt="" />
                                    </div>
                                    <div className="media-body event-resume">
                                        <h6>{(average_time / 60).toFixed(1)} <small> minutos </small></h6>
                                        <p><small> Es el tiempo promedio que los espectadores están viendo tu evento</small></p>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-6 mg-t-20 mg-sm-t-20">
                <div className="card card-minimal-four">
                    <div className="card-header">
                        <div className="media">
                            {(isLoading) && <i className="fas fa-spinner fa-spin"></i>}
                            {(!isLoading) && (
                                <React.Fragment>
                                    <div className="coin-logo">
                                        <img src={_peakLive} alt="" />
                                    </div>
                                    <div className="media-body event-resume">
                                        <h6>{viewers_peak} <small> espectador{(viewers_peak !== 1 ? "es" : "")} </small></h6>
                                        <p><small> Es tu audiencia máxima</small></p>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FirstRow;